import React, {useEffect, useState} from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {useGetRadii} from "../../api/get-radii";
import {SelectedMaterial} from "../../types/SelectedMaterial";
import {useGetColors} from "../../api/get-colors";
import {Color} from "../../types/Color";
import {formatNumber} from "devextreme/localization";

export function MaterialComparisonColumnControl({group, showPopup}: {
    group: SelectedMaterial,
    showPopup: (url: string, colorName: string) => void
}) {
    const context = useCountertops();
    const colors = useGetColors(context.dealerId, group.prodQteGrpID ?? 0, context.estimateDate, context.customerZip)
    const [sortedData, setSortedData] = useState<Color[][]>([]);

    useEffect(() => {
        let map = new Map<number, Color[]>();
        colors.data.map(color => {
            if (color.imageUrl === null || color.slabUrl === null)
                return;

            let arr = map.get(color.amount);
            if (arr === undefined) {
                arr = [];
                map.set(color.amount, arr);
            }
            arr.push(color);
        });
        let resultArray: Color[][] = [];
        Array.from(map.keys()).sort().forEach((value) => {
            let arr = map.get(value);
            if (arr !== undefined) {
                resultArray.push(arr);
            }
        });
        setSortedData(resultArray);

    }, [colors.data])

    if (colors.isLoading)
        return <></>

    return (
        <>
            <table className={'split-column'}>
                <tbody>
                {sortedData.map(colorArr =>
                    <tr key={colorArr[0].amount} style={{textAlign: 'center'}}>
                        <td>
                            {colorArr.map((color) =>
                                <a onClick={() => {
                                    showPopup(color.imageUrl, color.name);
                                }}>
                                    <img style={{
                                        width: "100px",
                                        height: "100px",
                                        border: '1px solid #ccc',
                                        margin: '5px',
                                        borderRadius: '50px',
                                        filter: 'drop-shadow(2px 2px 2px #ccc)'
                                    }} src={color.imageUrl}></img>
                                </a>
                            )}
                            <div style={{fontSize: '12px'}}>Total (w/o
                                tax): {formatNumber(colorArr[0].amount * context.shapes.reduce((accumulator, currentValue) => accumulator + (currentValue.total ?? 0), 0), 'currency')}</div>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </>
    );
}
